import Cookie from 'universal-cookie';
import { COOKIE_JWT_TOKEN_SIMAC } from 'constants/cookies';

const cookie = new Cookie();

export const authResponseSuccess = (response) => {
  try {
    const {
      data: { entity }
    } = response;
    const code = response.data.entity ? response.data.entity.code : response.data.code;
    if (code !== 200) {
      throw entity;
    }
  } catch (error) {
    // throw response.data;
    console.log(error);
  }
  return response;
};

export const authResponseFailed = (response) => {
  throw response;
};

export const authRequest = (config) => {
  const newConfig = config;
  const token = cookie.get(COOKIE_JWT_TOKEN_SIMAC);
  if (!newConfig.data) newConfig.data = {};
  if (token) {
    newConfig.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};
